module.exports = __webpack_public_path__ + "static/media/WhiteCloseIcon.72047aae.png";